import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  dialogText: {
    fontSize: "20px",
    padding: "8px",
    borderRadius: "8px",
    color: theme.palette.primary.main,
  },
  dateSeparator: {
    borderBottom: "1px solid rgb(230, 230, 230)",
    paddingBottom: "16px",
  },
}));
